import { Box, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
// import { tokens } from "../../../../../../theme";
import { tokens } from "../../../../../../theme";
import Text from "../../../../../../components/theme/text/Text";
import AddIcon from '@mui/icons-material/Add';
import ButtonGroup from "../../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../../components/theme/buttons/Shbutton";
import { useTranslation } from "react-i18next";
import ShDataGrid2 from "../../../../../../components/theme/datagrid2/ShDataGrid2";
import ShTextSkeleton from "../../../../../../components/theme/skeleton/ShTextSkeleton";
import { selectUserPermission } from "../../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../../../utils/permissions";
import { useSelector } from "react-redux";
import { GridCheckIcon } from "@mui/x-data-grid";
import { ClearIcon } from "@mui/x-date-pickers";
import MAddWhitelist from "../../../../../../components/global/Modals/MAddWhitelist";
import { useGetWhitelistsQuery } from "../../../../../../newapi/user/whitelistSlice";
import WhiteListCard from "../../../../../../components/global/cards/settings/WhiteListCard";
import SidepanelLoader from '../../../../../../components/theme/sidepanel2/SidepanelLoader';

const SpWhitelistDetails = SidepanelLoader(() => import("../../../../../../components/global/Sidepanels/SpWhitelistDetails/SpWhitelistDetails"));

const GridActions = (props, i18n) => {
    const theme = useTheme();
    useEffect(() => {},[props.open]);
    const {t} = useTranslation();

    return (      
        <ButtonGroup version={2}>
            {props.hasCreatePermission && (
            <Shbutton 
                onClick={() => props.handleOpen(true)}
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                variant="contained" 
                endIcon={<AddIcon/>}>{t("new_whitelist")}
                </Shbutton>
            )}
        </ButtonGroup>
    )
}


const gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
};


const All = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [isExtended,setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const hasCreatePermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.SETTINGS_USERPRIVILEGES])
    );

    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const [whitelistId, setWhitelistId] = useState();
    const whitelistIdRef = useRef(whitelistId);

    const getWhitelistDetails = (params) => {
        if (!params) return;

        const newWhitelistId = parseInt(params.row.id);
        if (whitelistIdRef.current !== newWhitelistId) {
            if (!spLoading) {
                setSpLoading(true);
            }
            setWhitelistId(newWhitelistId);
            whitelistIdRef.current = newWhitelistId;
        }
        setIsExtended(true);
    };

    const handleClose = () => {
        setAddModalOpen(false);
      };

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions:gridOptions,
            mobileActions:<GridActions hasCreatePermission={hasCreatePermission} handleOpen={() => setAddModalOpen(true)}></GridActions>
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[props]);


    
    
    const columns = [
        {field: "description", headerName: t("description") , flex:2, cellClassName: "user", renderCell : (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return params.value
        }},
        {field: "ipAddress", headerName: t("ip_address") , flex:2, cellClassName: "user",renderCell : (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return params.value
        }},
        {field: "globalLogin", headerName: t("global_login") , flex:2, cellClassName: "user",renderCell : (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return (
                <Box>
                    {params.value ? (
                        <GridCheckIcon sx={{ color: colors.green[400] }} />
                    ) : (
                        <ClearIcon sx={{ color: colors.red[400] }} />
                    )}
                </Box>
            )
        }},
        {field: "tagLogin", headerName: t("tag_login") , flex:2, cellClassName: "user",renderCell : (params) => {
            if(params.row.skeleton) {
                return <ShTextSkeleton/>
            }
            return (
                <Box>
                    <Text>
                        {params.value ? (
                            <GridCheckIcon sx={{ color: colors.green[400] }} />
                        ) : (
                            <ClearIcon sx={{ color: colors.red[400] }} />
                        )}
                    </Text>
                </Box>
            )
        }},
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <WhiteListCard
                        skeleton={params.row.skeleton ?? false}
                        onClick={() => getWhitelistDetails(params)}
                        {...params.row}
                    />
                )
                // return {
                //     <UserSett
                // }
                // console.log(cellValues.row);
               // return (
                    // <AllCarriersCard {...cellValues.row} />
               // )
            }
        }
    ];

    return (
        <Box
            sx={{
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >
            
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetWhitelistsQuery}
                gridActions={<GridActions hasCreatePermission={hasCreatePermission} handleOpen={() => setAddModalOpen(true)}></GridActions>}
                title={t("whitelists")}
                gridOptions={gridOptions}
                sortModel={{field: columns[0].field,type:"ASC"}}
                columns={columns}
                onRowClick={getWhitelistDetails}
                >
            </ShDataGrid2>

            <MAddWhitelist onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose}/>
            {spLoading &&
                <SpWhitelistDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    whitelistId={whitelistId}
                />
            }
        </Box>
    )
};

export default All;